module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a3"
  }, [_c('PinchInImg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPinchIn),
      expression: "showPinchIn"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "inner",
    class: _vm.cssLayoutID
  }, [_c('div', {
    staticClass: "toparea-image"
  }, [_c('div', {
    staticClass: "img-wrapper",
    on: {
      "touchstart": function($event) {
        return _vm.onTouchStart(_vm.currentData.image)
      },
      "touchend": function($event) {
        return _vm.onTouchEnd()
      },
      "touchmove": function($event) {
        return _vm.onTouchEnd()
      }
    }
  }, [(_vm.currentData != null) ? _c('img', {
    attrs: {
      "src": _vm.currentData.image
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "cards-container",
    class: _vm.templateTypes[0]
  }, [_vm._l((_vm.actGroupIndexList.length), function(index) {
    return _c('div', {
      key: index,
      staticClass: "card-inner",
      class: _vm.templateTypes[1]
    }, _vm._l((_vm.actGroupIndexList[index - 1]), function(item) {
      return _c('div', {
        key: item,
        staticClass: "item",
        class: {
          complete: _vm.questionStatus == 'end'
        }
      }, [_c('A3act', {
        attrs: {
          "act": _vm.pathstep.acts[item],
          "answer": _vm.currentData,
          "questionState": _vm.questionStatus,
          "index": item,
          "isSelect": _vm.isSelect
        },
        on: {
          "isCorrect": function($event) {
            return _vm.childIsCorrect()
          },
          "isInCorrect": function($event) {
            return _vm.childIsInCorrect()
          },
          "clickImage": function($event) {
            return _vm.clickItem(_vm.pathstep.acts[item], item)
          },
          "onTouchStart": _vm.onTouchStart,
          "onTouchEnd": _vm.onTouchEnd
        }
      })], 1)
    }), 0)
  }), _vm._v(" "), (_vm.isScrollIconVisible) ? _c('div', {
    staticClass: "icon-scroll"
  }) : _vm._e()], 2)])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-33df905b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-33df905b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/runmode/A3.vue
// module id = 615
// module chunks = 1